import { useTranslations } from "@shared/context/useTranslations";
import { cn } from "@shared/helpers/classNames.helper";
import { ProductStock } from "@shared/types/CategoryTypes.interface";
import { usePickupLocationsModal } from "@shared/hooks/usePickupLocationsModal";
import { formatStock } from "@shared/helpers/formatStock";
import S from "./StockStatus.module.scss";

interface StockStatusProps {
    stock: ProductStock;
}

const MAX_PICKUP_LOCATIONS = 3;

export const StockStatus = ({ stock }: StockStatusProps) => {
    const { getTranslation } = useTranslations();
    const { handlePickupClick } = usePickupLocationsModal();

    const availablePickup =
        stock.pickup?.filter(({ quantity }) => quantity > 0).slice(0, MAX_PICKUP_LOCATIONS) ?? [];

    return (
        <div className={S.stockStatusContainer}>
            {/* LOCAL */}
            {stock.local > 0 && (
                <div className={S.stockStatusWrapper}>
                    <span className={cn(S.stockStatusIcon, S.inLocalStockStatus)}></span>
                    <span className={S.stockStatusText}>
                        {`${getTranslation("general.on-stock")} (${formatStock(stock.local)})`}
                    </span>
                </div>
            )}

            {/* REMOTE */}
            {stock.remote > 0 && (
                <div className={S.stockStatusWrapper}>
                    <span className={cn(S.stockStatusIcon, S.inRemoteStockStatus)}></span>
                    <span className={S.stockStatusText}>
                        {`${getTranslation("general.on-remote-stock")} (${formatStock(stock.remote)})`}
                    </span>
                </div>
            )}

            {/* PICKUP */}
            {availablePickup.length > 0 && (
                <div className={S.stockStatusWrapper}>
                    <span className={cn(S.stockStatusIcon, S.inPickupStockStatus)}></span>
                    <button
                        className={cn(S.stockStatusBtn, S.stockStatusText)}
                        onClick={() => handlePickupClick(availablePickup)}
                    >
                        {`${getTranslation("general.on-pickup-stock")} (${formatStock(availablePickup.length)})`}
                    </button>
                </div>
            )}

            {/* NO STOCK */}
            {stock.remote === 0 && stock.local === 0 && availablePickup.length === 0 && (
                <div className={S.stockStatusWrapper}>
                    <span className={cn(S.stockStatusIcon)}></span>
                    <span className={S.stockStatusText}>
                        {getTranslation("general.out-of-stock")}
                    </span>
                </div>
            )}
        </div>
    );
};
